"use client";

import { useState } from "react";
import dynamic from "next/dynamic";
import type { LocaleKey } from "./copy";

// Quiz is dynamic+ssr:false to avoid bloating Hero TTFB / hydration.
const LeadQualificationQuiz = dynamic(() => import("./LeadQualificationQuiz"), {
  ssr: false,
});

interface Props {
  locale: LocaleKey;
  page: string;
  icp?: string;
  /** Visible title, e.g. "Wypełnij krótki quiz i otrzymaj checklistę" */
  title: string;
  /** Visible subtitle / value prop */
  sub?: string;
  /** Optional 3rd value-prop line */
  bonus?: string;
  /** CTA source ID for analytics */
  ctaSource: string;
  /** Optional className override; defaults to /oferta secondary CTA classes */
  className?: string;
}

/**
 * Reusable Hero secondary CTA — opens LeadQualificationQuiz modal.
 * Mirrors the secondary button visual from /oferta (oferta-cta-pdf class).
 * Used on /, /uslugi/wybor-mieszkania, /uslugi/kredyt-hipoteczny, /uslugi/sprzedaz.
 */
export default function HeroQuizButton({
  locale,
  page,
  icp = "general",
  title,
  sub,
  bonus,
  ctaSource,
  className,
}: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={className || "oferta-cta-pdf"}
        data-cta-source={ctaSource}
        onClick={() => setOpen(true)}
      >
        <div className="oferta-cta-pdf__inner">
          <div className="oferta-cta-pdf__icon-box" aria-hidden>📄</div>
          <div className="oferta-cta-pdf__text">
            <div className="oferta-cta-pdf__title">{title}</div>
            {sub && <div className="oferta-cta-pdf__sub">{sub}</div>}
            {bonus && <div className="oferta-cta-pdf__bonus">{bonus}</div>}
          </div>
        </div>
      </button>
      <LeadQualificationQuiz
        open={open}
        onClose={() => setOpen(false)}
        locale={locale}
        page={page}
        icp={icp}
      />
    </>
  );
}
